import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./context/AuthContext";
import { BrandingProvider } from "./context/BrandingContext";
import ProtectedRoute from "./components/ProtectedRoute";
import AppLayout from "./components/AppLayout";
import Login from "./pages/Login";
import ForgotPassword from "./pages/ForgotPassword";
import Dashboard from "./pages/Dashboard";
import OAHistory from "./pages/OAHistory";
import OAForm from "./pages/OAForm";
import OAPreview from "./pages/OAPreview";
import ViewAllPO from "./pages/ViewAllPO";
import Annexure from "./pages/Annexure";
import Quotation from "./pages/Quotation";
import Bill from "./pages/Bill";
import ImportOldOA from "./pages/ImportOldOA";
import ImportExport from "./pages/ImportExport";
import OARecords from "./pages/OARecords";
import OADetails from "./pages/OADetails";
import WorkOrders from "./pages/WorkOrders";
import OASearch from "./pages/OASearch";
import Masters from "./pages/Masters";
import MasterHub from "./pages/MasterHub";
import Customers from "./pages/Customers";
import Products from "./pages/Products";
import Employees from "./pages/Employees";
import Reports from "./pages/Reports";
import AuditLogs from "./pages/AuditLogs";
import Settings from "./pages/Settings";
import Profile from "./pages/Profile";

export default function App() {
  return (
    <BrandingProvider>
    <AuthProvider>
      <Toaster position="top-right" richColors />
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/oa/:id/preview" element={<ProtectedRoute><OAPreview /></ProtectedRoute>} />
          <Route element={<ProtectedRoute><AppLayout /></ProtectedRoute>}>
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/oa/new" element={<OAForm />} />
            <Route path="/oa/:id/edit" element={<OAForm />} />
            <Route path="/oa" element={<OAHistory />} />
            <Route path="/po" element={<ViewAllPO />} />
            <Route path="/annexure" element={<Annexure />} />
            <Route path="/quotation" element={<Quotation />} />
            <Route path="/bill" element={<Bill />} />
            <Route path="/import-old-oa" element={<ImportOldOA />} />
            <Route path="/import-export" element={<ImportExport />} />
            <Route path="/records/:module" element={<OARecords />} />
            <Route path="/work-orders" element={<WorkOrders />} />
            <Route path="/oa/:id/details" element={<OADetails />} />
            <Route path="/oa-search" element={<OASearch />} />
            <Route path="/masters" element={<MasterHub />} />
            <Route path="/masters/:mtype" element={<Masters />} />
            <Route path="/customers" element={<Customers />} />
            <Route path="/products" element={<Products />} />
            <Route path="/reports" element={<Reports />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/employees" element={<ProtectedRoute adminOnly><Employees /></ProtectedRoute>} />
            <Route path="/audit-logs" element={<ProtectedRoute adminOnly><AuditLogs /></ProtectedRoute>} />
            <Route path="/settings" element={<ProtectedRoute adminOnly><Settings /></ProtectedRoute>} />
          </Route>
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
    </BrandingProvider>
  );
}
